import styled from '@emotion/styled';
import { rem } from 'styles/utils/sizes';
import { Translate } from '../../translate';
import { ButtonBase, ButtonPrimary } from '../../button/button';

const PanoramicNavigationWrapper = styled.div`
    ${({
        theme: {
            base: { zindex }
        }
    }) => `
        height: ${rem(40)};
        position: absolute;
        z-index: ${zindex.above};

        ${ButtonBase} {
            position: fixed;
            bottom: 0;

            &[data-button='prevBtn'] {
                left: 0;
            }

            &[data-button='nextBtn'] {
                right: 0;
            }
        }
    `}
`;

export type PanoramicNavigationProps = {
    prevLabel?: string;
    nextLabel?: string;
    onClickPrev?: () => void;
    onClickNext?: () => void;
    isFontSizeLarge?: boolean;
};

const PanoramicNavigation = ({
    prevLabel,
    nextLabel,
    onClickPrev,
    onClickNext,
    isFontSizeLarge
}: PanoramicNavigationProps) => {
    return (
        <PanoramicNavigationWrapper>
            {onClickPrev && (
                <ButtonPrimary
                    iconName='arrow-left'
                    onClick={onClickPrev}
                    data-button='prevBtn'
                    isFontSizeLarge={isFontSizeLarge}
                >
                    {prevLabel ? (
                        prevLabel
                    ) : (
                        <Translate i18nKey='panoramic.prevBtnLabel' />
                    )}
                </ButtonPrimary>
            )}
            {onClickNext && (
                <ButtonPrimary
                    iconName='arrow-right'
                    onClick={onClickNext}
                    iconPosition='right'
                    data-button='nextBtn'
                    isFontSizeLarge={isFontSizeLarge}
                >
                    {nextLabel ? (
                        nextLabel
                    ) : (
                        <Translate i18nKey='panoramic.nextBtnLabel' />
                    )}
                </ButtonPrimary>
            )}
        </PanoramicNavigationWrapper>
    );
};

export { PanoramicNavigation, PanoramicNavigationWrapper };
